import type { PageEvent } from '@angular/material/paginator';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorIntlFr } from '@commons/bo-ui/pagination/paginator.intl';

@Component({
  selector: 'app-bo-pagination',
  standalone: true,
  template: `
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [length]="itemsCount"
      [pageSize]="itemsPerPage"
      [pageIndex]="currentPage"
      [showFirstLastButtons]="true"
      (page)="handlePaginationChange($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatPaginatorModule],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlFr }],
})
export class WzbBoPaginationComponent {
  @Input() itemsPerPage!: number;
  @Input() pageSizeOptions!: number[];
  @Input() itemsCount!: number;
  @Input() currentPage!: number;

  @Output() paginationChanged = new EventEmitter<PageEvent>();

  handlePaginationChange = (pageEvent: PageEvent): void => {
    this.paginationChanged.emit(pageEvent);
  };
}
